import { render } from "./SmallButtonComponent.vue?vue&type=template&id=a2e9be7e&scoped=true"
import script from "./SmallButtonComponent.vue?vue&type=script&lang=js"
export * from "./SmallButtonComponent.vue?vue&type=script&lang=js"

import "./SmallButtonComponent.vue?vue&type=style&index=0&id=a2e9be7e&scoped=true&lang=css"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2e9be7e"]])

export default __exports__